import { createStyles } from "@mantine/core";

export const useStyles = createStyles((theme, props, getRef) => ({
  innerInput: {
    color: "#212121",
    fontSize: 18,
    fontWeight: 400,
    height: 59,
    lineHeight: "27px",
    padding: "16px 24px",
  },
  input: {
    backgroundColor: "transparent",
    border: `2px solid #A6A6A6`,
    height: 59,
  },
  label: {
    color: "#212121",
    fontSize: 18,
    fontWeight: 700,
    lineHeight: "27px",
  },
}));
